<div class="full-view" [style]="'background-color:'+this.bgColor">
    <section class="left__content ">
        <div *ngIf="topLogo" class="logo__container">
            <img src="{{this.environment.assets.logo}}" alt="" srcset="">
        </div>

        <ng-container [ngTemplateOutlet]="content"></ng-container>

        <div *ngIf="bottomLogo" class="logo__footer">
            <img src="assets/images/spiral_black.svg" alt="">
        </div>
    </section>
    <section class="right__content " [style]="'background-image:url('+this.imgURL+')'">
    </section>
</div>